import { render, staticRenderFns } from "./BackgroundCheckForm.vue?vue&type=template&id=e08bccea&lang=pug"
import script from "./BackgroundCheckForm.vue?vue&type=script&lang=ts"
export * from "./BackgroundCheckForm.vue?vue&type=script&lang=ts"
import style0 from "./BackgroundCheckForm.vue?vue&type=style&index=0&id=e08bccea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports